import React from "react";

import type { LegalSection } from "./legal.types";
import LegalPageLayout from "./LegalPageLayout";

const intro = ["p1", "p2"] as const;

/** Section order and shape; the prose lives under `refundPolicy` in the legal namespace. */
const sections: LegalSection[] = [
	{ key: "whatYouArePayingFor", paragraphs: ["p1", "p2"] },
	{ key: "howToCancel", paragraphs: ["p1", "p2"] },
	{ key: "whatHappensWhenYouCancel", paragraphs: ["p1", "p2"] },
	{ key: "refunds", paragraphs: ["p1", "p2"] },
	{ key: "failedOrDuplicatePayments", paragraphs: ["p1", "p2"] },
	{ key: "priceChanges", paragraphs: ["p1"] },
	{ key: "contactUs", paragraphs: ["p1"] }
];

const RefundPolicyPage = () => {
	return <LegalPageLayout intro={intro} page="refundPolicy" sections={sections} />;
};

export default RefundPolicyPage;
